const BASE_URL = process.env.REACT_APP_API_URL ;
 
const getToken = () => localStorage.getItem("accessToken");

const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    console.log("RefreshToken in localStorage:", refreshToken);

    if (!refreshToken) {
      console.log("No refresh token found!");
      return null;
    }

    const res = await fetch(`${BASE_URL}/auth/refresh-token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken }),
    });

    const result = await res.json();
    console.log("Refresh result:", result);

    if (result?.data?.accessToken) {
      localStorage.setItem("token", result.data.accessToken);
      if (result?.data?.refreshToken) {
        localStorage.setItem("refreshToken", result.data.refreshToken);
      }
      return result.data.accessToken;
    }
    return null;
  } catch (err) {
    console.log("Refresh error:", err);
    return null;
  }
};

export const fetchWithAuth = async (url, options = {}) => {
  const token = getToken();

  const res = await fetch(url, {
    ...options,
    credentials: "include",
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.status === 401) {
    const newToken = await refreshAccessToken();
    if (!newToken) return res;

    return fetch(url, {
      ...options,
      credentials: "include",
      headers: {
        ...options.headers,
        Authorization: `Bearer ${newToken}`,
      },
    });
  }

  return res;
};

// =======================
// GET CART
// =======================
export const fetchCart = async () => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/cart`);
    return await res.json();
  } catch (error) {
    console.error("Fetch cart error:", error);
    return null;
  }
};

// =======================
// ADD ITEM
// =======================
export const addToCartAPI = async (productId, quantity = 1) => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/cart/add`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ productId, quantity }),
    });
    return await res.json();
  } catch (error) {
    console.error("Add cart error:", error);
    return null;
  }
};

// =======================
// UPDATE QTY
// =======================
export const updateCartQtyAPI = async (itemId, quantity) => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/cart/item/${itemId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity }),
    });
    return await res.json();
  } catch (error) {
    console.error("Update qty error:", error);
    return null;
  }
};

// =======================
// REMOVE ITEM
// =======================
export const removeCartItemAPI = async (itemId) => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/cart/item/${itemId}`, {
      method: "DELETE",
    });
    return await res.json();
  } catch (error) {
    console.error("Remove item error:", error);
    return null;
  }
};

// =======================
// CLEAR CART
// =======================
export const clearCartAPI = async () => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/cart/clear`, {
      method: "DELETE",
    });
    return await res.json();
  } catch (error) {
    console.error("Clear cart error:", error);
    return null;
  }
};

// =======================
// APPLY COUPON
// =======================
export const applyCouponAPI = async (code) => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/cart/coupon/apply`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code }),
    });
    return await res.json();
  } catch (error) {
    console.error("Apply coupon error:", error);
    return null;
  }
};

// =======================
// REMOVE COUPON
// =======================
export const removeCouponAPI = async () => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/cart/coupon/remove`, {
      method: "DELETE",
    });
    return await res.json();
  } catch (error) {
    console.error("Remove coupon error:", error);
    return null;
  }
};